var INPUT_BORDER = 1;
var START_DATE = 'Start day';
var END_DATE = 'End day';
export { END_DATE, INPUT_BORDER, START_DATE };